import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CopyAlbumLinkButton.module.css';
import { CC } from '../CC/CC';
import { useCCContext } from '../CC/CCContext';
import * as ccUtils from '../CC/utils';
import GenericIcon from '../GenericComponents/GenericIcon';

type CopyAlbumLinkButtonProps = {
  hyperlink?: string;
};

const CopyAlbumLinkButton: React.FC<CopyAlbumLinkButtonProps> = ({ hyperlink }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState<string | null>(null);
  const [messageVisible, setMessageVisible] = useState(false);
  const { cc } = useCCContext();

  const handleButtonClick = () => {
    const linkToCopy = hyperlink || ccUtils.GenerateStateHyperlink(cc);

    navigator.clipboard.writeText(linkToCopy).then(() => {
      setMessage(t('copy_hyperlink_ok'));
      setMessageVisible(true);

      setTimeout(() => {
        setMessageVisible(false);
      }, 3000);
    }).catch(err => {
      console.error('Failed to copy text: ', err);
      setMessage(t("copy_hyperlink_failed"));
      setMessageVisible(true);

      setTimeout(() => {
        setMessageVisible(false);
      }, 3000);
    });
  };

  return (
    <div className={styles.CopyAlbumLinkButton} onClick={() => {handleButtonClick()}}> 
      <GenericIcon
        icon='light/link.svg'
      />
      {messageVisible && (
        <div className={`${styles.message} ${messageVisible ? styles.fadeIn : styles.fadeOut}`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default CopyAlbumLinkButton;
